// src/fontawesome.ts
import { library } from '@fortawesome/fontawesome-svg-core';
import { faBars, faTimes, faHome, faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { faFacebook, faTwitter } from '@fortawesome/free-brands-svg-icons';
import { faCaretSquareDown, faEye, faHeart, faShareSquare, faCopy } from '@fortawesome/free-regular-svg-icons';
import { faDownload, faLayerGroup, faCaretDown } from '@fortawesome/free-solid-svg-icons';


library.add(
  faBars,
  faTimes,
  faHome,
  faPlusCircle,
  faCaretSquareDown,
  faFacebook,
  faTwitter,
  faEye,
  faHeart,
  faShareSquare,
  faDownload,
  faLayerGroup,
  faCaretDown,
  faCopy
  
);